"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = keys;

var _defs = _interopRequireDefault(require("../_core/defs"));

// returns an array which contains all data keys
function keys() {
  var def = _defs["default"].get(this);
  /* istanbul ignore if */


  if (!def) {
    return [];
  }

  return Object.keys(def.keys);
}
//# sourceMappingURL=keys.js.map